import { inject, Injectable } from '@angular/core';

import { FormStep, RoutesPath } from '@features/succession/enums';
import { CustomerInformation } from '@features/succession/models';
import { SuccessionFacade } from '@features/succession/succession.facade';

@Injectable({ providedIn: 'root' })
export class SummaryFacade {
  private readonly successionFacade = inject(SuccessionFacade);

  public cguAccepted = false;

  private navigateToPage(route: RoutesPath): void {
    const customerInformation: CustomerInformation = {
      token: this.successionFacade.token,
      savePage: FormStep.SIX,
      loadPage: route === RoutesPath.PAGE_5 ? FormStep.FIVE : FormStep.SEPT,
      deceasedInformations: undefined,
      deceasedMoreInformations: undefined,
      reporterInformations: undefined,
      notaryInformations: undefined,
      inheritanceInformations: undefined,
    };

    this.successionFacade.saveAndLoad(customerInformation);
  }

  public onPrevious(): void {
    this.navigateToPage(RoutesPath.PAGE_5);
    this.successionFacade.trackPrevious();
  }

  public onNext(): void {
    this.navigateToPage(RoutesPath.PAGE_7);
    this.successionFacade.trackNext();
  }
}
